
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion-finder-product",
      function () {
        return require("private-next-pages/fashion-finder-product.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashion-finder-product"])
      });
    }
  